// src/providers/AppProviders.js

import React from "react";

/* ---------------- Core Contexts ---------------- */
import { AuthProvider } from "../context/AuthContext";
import { CompanyProvider } from "../context/CompanyContext";
import { ProjectProvider } from "../context/ProjectContext";

/* ---------------- Feature Contexts ---------------- */
import { BillingProvider } from "../context/BillingContext";
// ❌ REMOVED PaymentProvider
import { NotificationProvider } from "../context/NotificationContext";

/* ===================================================== */
/* 🧠 Provider Composition                               */
/* ===================================================== */

export default function AppProviders({ children }) {
  return (
    <AuthProvider>
      <CompanyProvider>
        <ProjectProvider>

          {/* Feature Layer */}
          <BillingProvider>
            <NotificationProvider>

              {children}

            </NotificationProvider>
          </BillingProvider>

        </ProjectProvider>
      </CompanyProvider>
    </AuthProvider>
  );
}